/**
 * Browser detection functionality
 * Replicates the logic from Adobe Launch browser_details data element
 */ /**
 * Get browser details from navigator.userAgent
 * Replicates the logic from Adobe Launch browser_details data element
 */ export function getBrowserDetails() {
    const userAgent = navigator.userAgent;
    let name = 'Unknown';
    let version = 'Unknown';
    if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1 && userAgent.indexOf('OPR') === -1) {
        name = 'Chrome';
        const match = userAgent.match(/Chrome\/([0-9.]+)/);
        version = match?.[1] || 'Unknown';
    } else if (userAgent.indexOf('Edg') > -1) {
        name = 'Edge';
        const match = userAgent.match(/Edg\/([0-9.]+)/);
        version = match?.[1] || 'Unknown';
    } else if (userAgent.indexOf('Firefox') > -1) {
        name = 'Firefox';
        const match = userAgent.match(/Firefox\/([0-9.]+)/);
        version = match?.[1] || 'Unknown';
    } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
        name = 'Safari';
        const match = userAgent.match(/Version\/([0-9.]+)/);
        version = match?.[1] || 'Unknown';
    } else if (userAgent.indexOf('OPR') > -1) {
        name = 'Opera';
        const match = userAgent.match(/OPR\/([0-9.]+)/);
        version = match?.[1] || 'Unknown';
    } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1) {
        name = 'Internet Explorer';
        const match = userAgent.match(/(?:MSIE |rv:)([0-9.]+)/);
        version = match?.[1] || 'Unknown';
    }
    return {
        name,
        version
    };
}
